import React, { useState } from 'react'
import { AddContainer, Component4, Texts, HeaderPart, FooterPart, InputTextComponent, Component6, LabelWithTooltip } from './Style';
import NumberInput from 'src/components/shared/Form/Number';
import SwitchComponent from 'src/components/shared/Form/Switch';
import { Formik, Form } from 'formik';
import { Typography } from '@mui/material';

function TaskSetting({ data, setClinicProfileData, innerRef }) {
    const [total, setTotal] = useState(0);
    const sanitizeNumber = (value) => {
        return value === '' || value === undefined || value === null ? 0 : Number(value);
    };

    const initialValues = {
        // id: data?.id || '',
        followUpTask: data?.followUpTask || false,
        followUpTaskFrequency: data?.followUpTaskFrequency || 0,
        followUpTaskCount: data?.followUpTaskCount || 0,
        treatmentSchedulingReminderTask: data?.treatmentSchedulingReminderTask || false,
        treatmentSchedulingReminderTaskFrequency: data?.treatmentSchedulingReminderTaskFrequency || 0,
        treatmentSchedulingReminderTaskCount: data?.treatmentSchedulingReminderTaskCount || 0,
        patientFeedbackTask: data?.patientFeedbackTask || false,
        patientFeedbackTaskFrequency: data?.patientFeedbackTaskFrequency || 0,
        patientFeedbackTaskCount: data?.patientFeedbackTaskCount || 0,
        appointmentReminderTask: data?.appointmentReminderTask || false,
        appointmentReminderTaskFrequency: data?.appointmentReminderTaskFrequency || 0,
        appointmentReminderTaskCount: data?.appointmentReminderTaskCount || 0,
        paymentPendingReminderTask: data?.paymentPendingReminderTask || false,
        paymentPendingReminderTaskFrequency: data?.paymentPendingReminderTaskFrequency || 0,
        paymentPendingReminderTaskCount: data?.paymentPendingReminderTaskCount || 0,
        medicineReminderTask: data?.medicineReminderTask || false,
        medicineReminderTaskFrequency: data?.medicineReminderTaskFrequency || 0,
        medicineReminderTaskCount: data?.medicineReminderTaskCount || 0,
        healthCheckupTask: data?.healthCheckupTask || false,
        healthCheckupTaskFrequency: data?.healthCheckupTaskFrequency || 0,
        healthCheckupTaskCount: data?.healthCheckupTaskCount || 0,
        appointmentReschedulingTask: data?.appointmentReschedulingTask || false,
        appointmentReschedulingTaskFrequency: data?.appointmentReschedulingTaskFrequency || 0,
        appointmentReschedulingTaskCount: data?.appointmentReschedulingTaskCount || 0,
    };
    const handleSubmit = (values) => {

        setClinicProfileData(prev => ({
            ...prev,
            taskSetting: {
                ...values,
                followUpTaskFrequency: sanitizeNumber(values.followUpTaskFrequency),
                followUpTaskCount: sanitizeNumber(values.followUpTaskCount),
                treatmentSchedulingReminderTaskFrequency: sanitizeNumber(values.treatmentSchedulingReminderTaskFrequency),
                treatmentSchedulingReminderTaskCount: sanitizeNumber(values.treatmentSchedulingReminderTaskCount),
                patientFeedbackTaskFrequency: sanitizeNumber(values.patientFeedbackTaskFrequency),
                patientFeedbackTaskCount: sanitizeNumber(values.patientFeedbackTaskCount),
                appointmentReminderTaskFrequency: sanitizeNumber(values.appointmentReminderTaskFrequency),
                appointmentReminderTaskCount: sanitizeNumber(values.appointmentReminderTaskCount),
                paymentPendingReminderTaskFrequency: sanitizeNumber(values.paymentPendingReminderTaskFrequency),
                paymentPendingReminderTaskCount: sanitizeNumber(values.paymentPendingReminderTaskCount),
                medicineReminderTaskFrequency: sanitizeNumber(values.medicineReminderTaskFrequency),
                medicineReminderTaskCount: sanitizeNumber(values.medicineReminderTaskCount),
                healthCheckupTaskFrequency: sanitizeNumber(values.healthCheckupTaskFrequency),
                healthCheckupTaskCount: sanitizeNumber(values.healthCheckupTaskCount),
                appointmentReschedulingTaskFrequency: sanitizeNumber(values.appointmentReschedulingTaskFrequency),
                appointmentReschedulingTaskCount: sanitizeNumber(values.appointmentReschedulingTaskCount),

            }
        }));
    };

    const isRestricted = true;
    const allowedFields = ['followUpTask', 'followUpTaskFrequency', 'followUpTaskCount'];

    const getFieldProps = (name) => ({
        disabled: isRestricted && !allowedFields.includes(name),
        restrictionNote: isRestricted && !allowedFields.includes(name) ? (
            <Typography variant="caption" color="error">
                This feature is not available for you yet.
            </Typography>
        ) : null
    });
    const { disabled, restrictionNote } = getFieldProps('emergencyAvailability');

    return (
        <>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                innerRef={innerRef}

            >

                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (

                    <Form>
                        <AddContainer>
                            <Component6 >
                                <Texts>
                                    <LabelWithTooltip
                                        label="FollowUp Task"
                                        tooltip="Enable to assign automated follow-up tasks after appointments."
                                    />
                                </Texts>
                                <SwitchComponent
                                    name="followUpTask"
                                    checked={values.followUpTask}
                                    onChange={() => setFieldValue('followUpTask', !values.followUpTask)}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component4>
                                <Texts>
                                    <LabelWithTooltip
                                        label="FollowUp Task Frequency"
                                        tooltip="Set the interval (in days) between each follow-up task."
                                    />
                                </Texts>
                                <NumberInput
                                    name="followUpTaskFrequency"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.followUpTaskFrequency}
                                    onChange={(val) => setFieldValue('followUpTaskFrequency', val)}
                                />

                            </Component4>
                            <Component4>
                                <Texts>
                                    <LabelWithTooltip
                                        label="FollowUp Task Count"
                                        tooltip="Number of follow-up tasks to schedule for each patient."
                                    />
                                </Texts>
                                <NumberInput
                                    name="followUpTaskCount"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.followUpTaskCount}
                                    onChange={(val) => setFieldValue('followUpTaskCount', val)}
                                />

                            </Component4>
                            <Component6 >
                                <Texts>
                                    <LabelWithTooltip
                                        label="Treatment Scheduling Reminder Task"
                                        tooltip="Enable reminders for patients to schedule their next treatment."
                                    />
                                </Texts>
                                <SwitchComponent
                                    name="treatmentSchedulingReminderTask"
                                    checked={values.treatmentSchedulingReminderTask}
                                    onChange={() => setFieldValue('treatmentSchedulingReminderTask', !values.treatmentSchedulingReminderTask)}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component6>
                            <Component4>
                                <Texts>
                                    <LabelWithTooltip
                                        label="Treatment Scheduling Reminder Task Frequency"
                                        tooltip="Interval (in days) to send scheduling reminders."
                                    />
                                </Texts>
                                <NumberInput
                                    name="treatmentSchedulingReminderTaskFrequency"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.treatmentSchedulingReminderTaskFrequency}
                                    onChange={(val) => setFieldValue('treatmentSchedulingReminderTaskFrequency', val)}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component4>
                            <Component4>
                                <Texts>
                                    <LabelWithTooltip
                                        label="Treatment Scheduling Reminder Task Count"
                                        tooltip="Number of reminders to send for treatment scheduling."
                                    />
                                </Texts>
                                <NumberInput
                                    name="treatmentSchedulingReminderTaskCount"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.treatmentSchedulingReminderTaskCount}
                                    onChange={(val) => setFieldValue('treatmentSchedulingReminderTaskCount', val)}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component4>
                            <Component6 >
                                <Texts>
                                    <LabelWithTooltip
                                        label="In Person At Home"
                                        tooltip="Indicates if the doctor is available for home visits."
                                    />
                                </Texts>
                                <SwitchComponent
                                    name="inPersonAtHome"
                                    checked={values.inPersonAtHome}
                                    onChange={() => setFieldValue('inPersonAtHome', !values.inPersonAtHome)}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component6>
                            <Component6 >
                                <Texts>
                                    <LabelWithTooltip
                                        label="Patient Feedback Task"
                                        tooltip="Enable automated feedback collection after consultation."
                                    />
                                </Texts>
                                <SwitchComponent
                                    name="patientFeedbackTask"
                                    checked={values.patientFeedbackTask}
                                    onChange={() => setFieldValue('patientFeedbackTask', !values.patientFeedbackTask)}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component6>
                            <Component6 >
                                <Texts>
                                    <LabelWithTooltip
                                        label="Emergency Availability"
                                        tooltip="Indicates doctor’s availability for emergency services."
                                    />
                                </Texts>
                                <SwitchComponent
                                    name="emergencyAvailability"
                                    checked={values.emergencyAvailability}
                                    onChange={() => setFieldValue('emergencyAvailability', !values.emergencyAvailability)}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component6>
                            <Component4>
                                <Texts>
                                    <LabelWithTooltip
                                        label="Patient Feedback Task Frequency"
                                        tooltip="Days between feedback messages sent to patients."
                                    />
                                </Texts>
                                <NumberInput
                                    name="patientFeedbackTaskFrequency"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.patientFeedbackTaskFrequency}
                                    onChange={(val) => setFieldValue('patientFeedbackTaskFrequency', val)}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component4>
                            <Component4>
                                <Texts>
                                    <LabelWithTooltip
                                        label="Patient Feedback Task Count"
                                        tooltip="Total number of feedback requests sent to a patient."
                                    />
                                </Texts>
                                <NumberInput
                                    name="patientFeedbackTaskCount"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.patientFeedbackTaskCount}
                                    onChange={(val) => setFieldValue('patientFeedbackTaskCount', val)}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component4>
                            <Component6 >
                                <Texts>
                                    <LabelWithTooltip
                                        label="Appointment Reminder Task"
                                        tooltip="Enable reminders before upcoming appointments."
                                    />
                                </Texts>
                                <SwitchComponent
                                    name="appointmentReminderTask"
                                    checked={values.appointmentReminderTask}
                                    onChange={() => setFieldValue('appointmentReminderTask', !values.appointmentReminderTask)}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component6>
                            <Component4>
                                <Texts>
                                    <LabelWithTooltip
                                        label="Appointment Reminder Task Frequency"
                                        tooltip="Interval (in days) before the appointment to send reminders."
                                    />
                                </Texts>
                                <NumberInput
                                    name="appointmentReminderTaskFrequency"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.appointmentReminderTaskFrequency}
                                    onChange={(val) => setFieldValue('appointmentReminderTaskFrequency', val)}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component4>
                            <Component4>
                                <Texts>
                                    <LabelWithTooltip
                                        label="Appointment Reminder Task Count"
                                        tooltip="Number of appointment reminders to send."
                                    />
                                </Texts>
                                <NumberInput
                                    name="appointmentReminderTaskCount"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.appointmentReminderTaskCount}
                                    onChange={(val) => setFieldValue('appointmentReminderTaskCount', val)}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component4>
                            <Component6 >
                                <Texts><LabelWithTooltip
                                    label="Payment Pending Reminder Task"
                                    tooltip="Enable automated reminders for unpaid bills."
                                />
                                </Texts>
                                <SwitchComponent
                                    name="paymentPendingReminderTask"
                                    checked={values.paymentPendingReminderTask}
                                    onChange={() => setFieldValue('paymentPendingReminderTask', !values.paymentPendingReminderTask)}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component6>
                            <Component4>
                                <Texts>

                                    <LabelWithTooltip
                                        label="Payment Pending Reminder Task Frequency"
                                        tooltip="Interval (in days) to send payment pending reminders."
                                    />
                                </Texts>
                                <NumberInput
                                    name="paymentPendingReminderTaskFrequency"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.paymentPendingReminderTaskFrequency}
                                    onChange={(val) => setFieldValue('paymentPendingReminderTaskFrequency', val)}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component4>
                            <Component4>
                                <Texts>
                                    <LabelWithTooltip
                                        label="Payment Pending Reminder Task Count"
                                        tooltip="Number of payment reminders to be sent to a patient."
                                    />
                                </Texts>
                                <NumberInput
                                    name="paymentPendingReminderTaskCount"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.paymentPendingReminderTaskCount}
                                    onChange={(val) => setFieldValue('paymentPendingReminderTaskCount', val)}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component4>
                            <Component6 >
                                <Texts>
                                    <LabelWithTooltip
                                        label="Medicine Reminder Task"
                                        tooltip="Enable to send reminders to patients for taking medicines."
                                    />
                                </Texts>
                                <SwitchComponent
                                    name="medicineReminderTask"
                                    checked={values.medicineReminderTask}
                                    onChange={() => setFieldValue('medicineReminderTask', !values.medicineReminderTask)}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component6>
                            <Component4>
                                <Texts>
                                    <LabelWithTooltip
                                        label="Medicine Reminder Task Frequency"
                                        tooltip="How often to send medicine reminders (in days)."
                                    />
                                </Texts>
                                <NumberInput
                                    name="medicineReminderTaskFrequency"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.medicineReminderTaskFrequency}
                                    onChange={(val) => setFieldValue('medicineReminderTaskFrequency', val)}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component4>
                            <Component4>
                                <Texts>
                                    <LabelWithTooltip
                                        label="Medicine Reminder Task Count"
                                        tooltip="Total number of medicine reminders to send per prescription."
                                    />
                                </Texts>
                                <NumberInput
                                    name="medicineReminderTaskCount"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.medicineReminderTaskCount}
                                    onChange={(val) => setFieldValue('medicineReminderTaskCount', val)}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component4>
                            <Component6 >
                                <Texts>
                                    <LabelWithTooltip
                                        label="Health Checkup Task"
                                        tooltip="Enable reminders for periodic health checkups."
                                    />
                                </Texts>
                                <SwitchComponent
                                    name="healthCheckupTask"
                                    checked={values.healthCheckupTask}
                                    onChange={() => setFieldValue('healthCheckupTask', !values.healthCheckupTask)}
                                    disabled={disabled}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                                {restrictionNote}
                            </Component6>
                            <Component4>
                                <Texts>
                                    <LabelWithTooltip
                                        label="Health Checkup Task Frequency"
                                        tooltip="Days between health checkup reminders."
                                    />
                                </Texts>
                                <NumberInput
                                    name="healthCheckupTaskFrequency"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.healthCheckupTaskFrequency}
                                    onChange={(val) => setFieldValue('healthCheckupTaskFrequency', val)}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component4>
                            <Component4>
                                <Texts>
                                    <LabelWithTooltip
                                        label="Health Checkup Task Count"
                                        tooltip="Number of health checkup reminders to send."
                                    />
                                </Texts>
                                <NumberInput
                                    name="healthCheckupTaskCount"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.healthCheckupTaskCount}
                                    onChange={(val) => setFieldValue('healthCheckupTaskCount', val)}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component4>
                            <Component6 >
                                <Texts>
                                    <LabelWithTooltip
                                        label="Appointment Rescheduling Task"
                                        tooltip="Enable reminders to patients who missed their appointment."
                                    />
                                </Texts>
                                <SwitchComponent
                                    name="appointmentReschedulingTask"
                                    checked={values.appointmentReschedulingTask}
                                    onChange={() => setFieldValue('appointmentReschedulingTask', !values.appointmentReschedulingTask)}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component6>
                            <Component4>
                                <Texts>
                                    <LabelWithTooltip
                                        label="Appointment Rescheduling Task Frequency"
                                        tooltip="Interval (in days) between rescheduling reminders."
                                    />
                                </Texts>
                                <NumberInput
                                    name="appointmentReschedulingTaskFrequency"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.appointmentReschedulingTaskFrequency}
                                    onChange={(val) => setFieldValue('appointmentReschedulingTaskFrequency', val)}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component4>
                            <Component4>
                                <Texts>
                                    <LabelWithTooltip
                                        label="Appointment Rescheduling Task Count"
                                        tooltip="Number of rescheduling reminders to send."
                                    />
                                </Texts>
                                <NumberInput
                                    name="appointmentReschedulingTaskCount"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.appointmentReschedulingTaskCount}
                                    onChange={(val) => setFieldValue('appointmentReschedulingTaskCount', val)}
                                    disabled={disabled}
                                />
                                {restrictionNote}
                            </Component4>


                        </AddContainer>
                    </Form>

                )}
            </Formik>
        </>
    )
}

export default React.memo(TaskSetting);

